import { graphqlOperation } from 'aws-amplify'

import { GRAPHQL_URL } from './config'
import { getCognitoData, makeGraphqlRequest } from '../utils'

export const getPermissions = async () => {
  try {
    const query = /* GraphQL */ `
      query getAllPermissions {
        getAllPermissions {
          id
          operationType
          resourceType
          resourceId
        }
      }
    `

    const { idToken } = await getCognitoData()
    const operation = graphqlOperation(query, {})
    const { data, error } = await makeGraphqlRequest(
      GRAPHQL_URL,
      operation,
      idToken
    )

    if (error) {
      return {
        permissions: null,
        error: `Permissions not fetched: ${error}`
      }
    }

    return { permissions: data?.getAllPermissions, error }
  } catch (err) {
    return { permissions: null, error: err.message }
  }
}
